export default __webpack_public_path__ + "static/digi-winning-b6630d6045c13a42d4ee309c0e95898b.webp";